/**
 * Visualization Configuration
 *
 * Central settings for canvas-based visualizations.
 */

/**
 * Canvas pixel ratio for high-DPI/retina displays.
 * Higher values = sharper rendering but more GPU work.
 * - 1.0: Standard resolution
 * - 1.5: Good balance for retina
 * - 2.0: Full retina (may be overkill)
 */
export const CANVAS_PIXEL_RATIO = 1.5;

/**
 * Get canvas dimensions for rendering.
 * Returns internal resolution (larger) for sharp display.
 */
export function getCanvasSize(displayWidth: number, displayHeight: number): { width: number; height: number } {
  return {
    width: Math.round(displayWidth * CANVAS_PIXEL_RATIO),
    height: Math.round(displayHeight * CANVAS_PIXEL_RATIO)
  };
}
